// Pantalla `command="error"`. Renderiza data.message.summary como HTML
// (lo trae KC pre-formateado); botón "Volver" si hay clientBaseUrl. El
// botón es popup-aware (cierra ventana cuando window.opener está presente)
// vía PopupAwareBackButton.

import type { KcData } from "../kcData";
import { PopupAwareBackButton } from "../components/PopupAwareBackButton";
import { StandardPage } from "../components/StandardPage";

export interface ErrorPageProps {
  data: KcData;
}

export function ErrorPage({ data }: ErrorPageProps) {
  return (
    <StandardPage page="error" data={data}>
      <div className="kc-error-message">
        <p
          className="instruction"
          dangerouslySetInnerHTML={{
            __html: data.message?.summary ?? "",
          }}
        />
        {data.clientBaseUrl ? (
          <p>
            <PopupAwareBackButton href={data.clientBaseUrl} />
          </p>
        ) : null}
      </div>
    </StandardPage>
  );
}
